import { useMemo } from 'react';
import './repairDetailInformation.css';
import { ChangeDeadlineNoteCard } from './repairInfoDetail/changeExpiryNoteCard';
import { RepairProgressButton } from './repairInfoDetail/repairDetailButtonField';
import { RepairProgressFactoryField } from './repairInfoDetail/repairDetailFactoryField';
import { RepairProgressInsuranceField } from './repairInfoDetail/repairDetailInsuranceField';
import { RepairProgressReserveField } from './repairInfoDetail/repairDetailReserveField';
import { RepairProgressStatusField } from './repairInfoDetail/repairDetailStatusField';
import { BODY_PAINT_STATE } from '@/consts/bodyAndPaint';
import { RepairDetailDataType } from '@/types/bodyAndPaint';

interface RepairDetailInformationProps {
  data: RepairDetailDataType;
  openInsuranceModal: () => void;
  changeCheckInReserve: () => void;
  cancelCheckInReserve: () => void;
  onCheckRepairImage: () => void;
  onPickUpReserve: () => void;
  bp_status: number;
}
export const RepairDetailInformation = ({
  data,
  openInsuranceModal,
  changeCheckInReserve,
  cancelCheckInReserve,
  onCheckRepairImage,
  onPickUpReserve,
  bp_status,
}: RepairDetailInformationProps) => {
  const { stateInfo, reserveInfo, insuranceInfo, factoryInfo, checkInDate } =
    useMemo(() => {
      return {
        stateInfo: data?.state_info,
        reserveInfo: data?.reserve_info,
        insuranceInfo: data?.insurance_info,
        factoryInfo: data?.factory_info,
        checkInDate: data?.reserve_info?.check_in_date as Date,
      };
    }, [data]);
  return (
    <div className={'repair-detail-information-field'}>
      <RepairProgressStatusField
        info={stateInfo}
        checkRepairImage={onCheckRepairImage}
        pickUpReserve={onPickUpReserve}
      />
      <RepairProgressReserveField info={reserveInfo} />
      {insuranceInfo && (
        <RepairProgressInsuranceField
          info={insuranceInfo}
          onClick={openInsuranceModal}
        />
      )}
      <RepairProgressFactoryField info={factoryInfo} />
      {bp_status == BODY_PAINT_STATE.ACCIDENT_ACCEPT && (
        <ChangeDeadlineNoteCard date={checkInDate} />
      )}
      {bp_status == BODY_PAINT_STATE.ACCIDENT_ACCEPT && (
        <RepairProgressButton
          changeCheckInDate={changeCheckInReserve}
          cancelCheckInDate={cancelCheckInReserve}
        />
      )}
    </div>
  );
};
